export default {
  apiKey: 'AIzaSyDLwYL6ugSjF-4G190g-cNC4kv0q2w7P68',
  authDomain: 'water-level-tracking.firebaseapp.com',
  databaseURL: 'https://water-level-tracking.firebaseio.com',
  projectId: 'water-level-tracking',
  storageBucket: 'water-level-tracking.appspot.com',
  messagingSenderId: '411862773784',
  appId: '1:411862773784:web:9673811ab1ac318f'
}